<div [ngClass]="{on:val,off:val===false}"><div></div></div>